export default "__VITE_ASSET__pgk1hNLi__"